import * as $18n from '@alife/lazada-i18n';
import ScreenShotCut from 'js-web-screen-shot';
import React, { useContext } from 'react';
import { FeedbackContext } from '../../context';
import { screenshotDataURItoBlob } from './utils';
export const ScreenShot = ({
  uploading,
  preCheck,
  beforeUpload,
  handleUpload,
}: {
  uploading: boolean;
  preCheck: () => boolean;
  beforeUpload: (file: any) => boolean;
  handleUpload: (file: any) => Promise<void>;
}) => {
  const { onScreenshotStart, onScreenshotEnd, disableScreenshot } = useContext(FeedbackContext);

  if (disableScreenshot) return <></>;

  const handleClick = async () => {
    const check = preCheck();
    if (!check) return;
    onScreenshotStart?.();
    new ScreenShotCut({
      enableWebRtc: true,
      level: 999,
      toolPosition: 'right',
      hiddenToolIco: {
        rightTop: true,
      },
      cancelCallback() {
        onScreenshotEnd?.();
      },
      completeCallback(imgInfo) {
        onScreenshotEnd?.();
        const file: any = screenshotDataURItoBlob(imgInfo?.base64);
        const pass = beforeUpload(file);
        if (!pass) return;
        handleUpload(file);
      },
    });
  };

  return (
    <div
      className={`asc-feedback-screenshot ${uploading ? 'asc-feedback-screenshot-uploading' : ''}`}
      style={{ marginRight: 0 }}
      onClick={handleClick}
    >
      <div className="asc-feedback-screenshot-inner">
        <img
          className="asc-fb__screenshot-button--icon"
          src={'//lzd-img-global.slatic.net/g/tps/imgextra/i3/O1CN01bGqE191ZnVj3EVuCf_!!6000000003239-55-tps-25-24.svg'}
        />
        <div>{/*#__PURE__*/$18n.get('asc-fb.feedback-form.screenshot', 'Screenshot')}</div>
      </div>
    </div>
  );
};
